// KC-CINEM 003.1 — THE TECHCARE REAPER
// Approved source assets (created & curated by Kendi Collections for MOIRÉ).
// Delivered as SEO-named WebP from the MOIRÉ static origin (/public/kc-cinem/).
// Source artwork is preserved — only format-converted for web delivery.
const DIR = "/kc-cinem/";
export const SITE = "https://moire.live";
export const KC_ROUTE = "/collections/kc-cinem-003-1";
export const KC_CANONICAL = `${SITE}${KC_ROUTE}`;
export const KENDI_URL = "https://kendicollections.shop";

export const KC = {
  character: {
    src: DIR + "kendi-collections-moire-kc-cinem-003-1-techcare-reaper-original-character.webp",
    w: 1024, h: 1536,
    alt: "KC-CINEM 003.1 Techcare Reaper original character artwork — a hooded skeletal figure in matte black and crimson looking down at a burgundy smartphone.",
  },
  mask: {
    src: DIR + "kendi-collections-moire-kc-cinem-003-1-techcare-reaper-mask-front-interior.webp",
    w: 2000, h: 1000,
    alt: "KC-CINEM 003.1 Techcare Reaper porcelain mask front and Kendi Collections branded interior.",
  },
  guardian: {
    src: DIR + "kendi-collections-moire-kc-cinem-003-1-techcare-guardian-trench-coat.webp",
    w: 1536, h: 1024,
    alt: "KC-CINEM 003.1 Techcare Guardian Trench Coat design documentation — matte-black technical shell with crimson interior, modular utility straps and Kendi Collections branded webbing.",
  },
  womens: {
    src: DIR + "kendi-collections-moire-kc-cinem-003-1-techcare-reaper-womens-ensemble-front-back.webp",
    w: 1312, h: 1199,
    alt: "KC-CINEM 003.1 Techcare Reaper women's configuration ensemble visualization, front and back.",
  },
  unisex: {
    src: DIR + "kendi-collections-moire-kc-cinem-003-1-techcare-reaper-unisex-ensemble-front-back.webp",
    w: 1312, h: 1199,
    alt: "KC-CINEM 003.1 Techcare Reaper unisex configuration ensemble visualization, front and back.",
  },
  // ---- Phase 2 additions -------------------------------------------------
  tee: {
    src: DIR + "kendi-collections-moire-kc-cinem-003-1-techcare-reaper-graphic-tee-front-back-design.webp",
    w: 1536, h: 1024,
    alt: "KC-CINEM 003.1 Techcare Reaper black graphic tee front and back design by Kendi Collections for MOIRÉ.",
  },
  splitHemTrousers: {
    src: DIR + "kendi-collections-moire-kc-cinem-003-1-techcare-reaper-split-hem-utility-trousers-tech-pack.webp",
    w: 1536, h: 1024,
    alt: "KC-CINEM 003.1 Techcare Split-Hem Utility Trousers tech-pack with wide-leg construction, utility straps and crimson accordion zipper gusset.",
  },
  footwear: {
    src: DIR + "kendi-collections-moire-kc-cinem-003-1-techcare-reaper-corset-laced-socks-platform-boots-tech-pack.webp",
    w: 1536, h: 1024,
    alt: "KC-CINEM 003.1 Techcare Reaper knee-high corset-laced socks with 10312026 Kendi Collections top-band branding and black platform combat boots.",
  },
  splitHemEnsemble: {
    src: DIR + "kendi-collections-moire-kc-cinem-003-1-techcare-reaper-split-hem-ensemble-front-back.webp",
    w: 1312, h: 1199,
    alt: "KC-CINEM 003.1 Techcare Reaper Split-Hem Ensemble front and back with Guardian Trench Coat, graphic tee, utility trousers and platform boots.",
  },
};

// absolute URL helper for OG / Twitter / JSON-LD
export const abs = (src) => `${SITE}${src}`;

// the wide mask board is the strongest share image (2000x1000 ~ landscape)
export const KC_SHARE_IMAGE = abs(KC.mask.src);

export const KC_JSONLD = {
  "@context": "https://schema.org",
  "@type": "CreativeWork",
  name: "KC-CINEM 003.1 — The Techcare Reaper",
  alternateName: "The Techcare Reaper",
  identifier: "KC-CINEM-003.1",
  url: KC_CANONICAL,
  genre: "Fashion and costume concept",
  description:
    "An original fashion and costume concept created and curated by Kendi Collections for MOIRÉ, exploring mask, modular outerwear, utility silhouettes and crimson-black design.",
  creator: { "@type": "Organization", name: "Kendi Collections", url: KENDI_URL },
  publisher: { "@type": "Organization", name: "MOIRÉ", url: SITE },
  brand: { "@type": "Brand", name: "MOIRÉ" },
  isBasedOn: KENDI_URL,
  sameAs: [KENDI_URL],
  image: [KC.character, KC.mask, KC.guardian, KC.womens, KC.unisex, KC.tee, KC.splitHemTrousers, KC.footwear, KC.splitHemEnsemble].map((a) => ({
    "@type": "ImageObject",
    url: abs(a.src),
    width: a.w,
    height: a.h,
  })),
};
